import { ReadOnlyTypography } from '@warehouse/shared/ui';
import React, { useMemo } from 'react';
import TextInput from '../../../library/TextInput';
import TitleEditableField from '../../TitleEditableField';

interface SequenceNumberFieldProps {
	isInherited: boolean;
	sequenceNumber: string;
	setSequenceNumber: (sequenceNumber: string) => void;
	onBlur: () => void;
}

function SequenceNumberField({ sequenceNumber, setSequenceNumber, isInherited, onBlur }: SequenceNumberFieldProps) {
	return useMemo(
		() => (
			<TitleEditableField
				label="Sequence Number:"
				path="coreMetadata.basic.parents.sequenceInfo.number"
				jumpToParentButtonDisabled
				tooltipDisabled
				readComponent={
					<ReadOnlyTypography variant={isInherited ? 'prefilled' : 'default'}>{sequenceNumber}</ReadOnlyTypography>
				}
				editComponent={
					<TextInput
						type="number"
						fullWidth
						variant={isInherited ? 'prefilled' : 'default'}
						value={sequenceNumber}
						onChange={(e) => setSequenceNumber(e.target.value)}
						onBlur={onBlur}
						height={38}
						width="50%"
					/>
				}
			/>
		),
		[sequenceNumber, isInherited],
	);
}

export default SequenceNumberField;
